import ClearContactIfNotFoundModalHtml     from './templates/support/xero/clearContactIfNotFound.modal.html';
import FindInvoiceByInvoiceNumberModalHtml from './templates/support/xero/findInvoiceByInvoiceNumber.modal.html';
import FindMatchesForInvoiceModalHtml      from './templates/support/xero/findMatchesForInvoice.modal.html';
import FindPaymentsForInvoiceModalHtml     from './templates/support/xero/findPaymentsForInvoice.modal.html';
import FindSingleContactModalHtml          from './templates/support/xero/findSingleContact.modal.html';
import UploadAndResponseModalHtml          from './templates/support/xero/uploadAndResponse.modal.html';

export function XeroSupport ($uibModal, sessionObjAPI) {
  var XeroSupport = function() {};

  XeroSupport.prototype.find_payments_for_invoice = function (payments) {
    return $uibModal.open({
      templateUrl: FindPaymentsForInvoiceModalHtml,
      windowClass: 'lg-modal flip-container',
      controller: 'XeroSupportFindPaymentsCtrl',
      resolve: {
        payments: [ function () {
          return payments;
        }]
      }
    }).result;
  };

  XeroSupport.prototype.find_matches_for_invoice = function (invoices) {
    return $uibModal.open({
      templateUrl: FindMatchesForInvoiceModalHtml,
      windowClass: 'lg-modal flip-container',
      controller: 'XeroSupportFindMatchesForInvoiceCtrl',
      resolve: {
        invoices: [ function () {
          return invoices;
        }]
      }
    }).result;
  };

  XeroSupport.prototype.find_contact_by_id = function (contact) {
    return $uibModal.open({
      templateUrl: FindSingleContactModalHtml,
      windowClass: 'lg-modal',
      controller: 'XeroSupportFindContactByIdCtrl',
      resolve: {
        contact: [ function () {
          return contact;
        }]
      }
    }).result;
  };

  XeroSupport.prototype.clear_contact_if_not_found = function (contact) {
    return $uibModal.open({
      templateUrl: ClearContactIfNotFoundModalHtml,
      windowClass: 'lg-modal',
      controller: 'XeroSupportClearContactIfNotFoundCtrl',
      resolve: {
        contact: [ function () {
          return contact;
        }]
      }
    }).result;
  };

  XeroSupport.prototype.find_invoice_by_invoice_number = function (invoice) {
    return $uibModal.open({
      templateUrl: FindInvoiceByInvoiceNumberModalHtml,
      windowClass: 'lg-modal',
      controller: 'XeroSupportFindInvoiceByInvoiceNumberCtrl',
      resolve: {
        invoice: [ function () {
          return invoice;
        }]
      }
    }).result;
  };

  XeroSupport.prototype.upload_and_response = function (result) {
    return $uibModal.open({
      templateUrl: UploadAndResponseModalHtml,
      windowClass: 'lg-modal',
      controller: 'XeroSupportUploadAndResponseCtrl',
      resolve: {
        result: [ function () {
          return result;
        }]
      }
    }).result;
  };

  return XeroSupport;
}